const baseUrls = {
    deviceManagement: 'https://service-energydevicemanagement-uat.tesvolt.com',
    dataAggregator: 'https://service-energydataaggregator-uat.tesvolt.com',
    dataCollector: 'https://service-energydatacollector-uat.tesvolt.com',
    identity: 'https://service-energyidentity-uat.tesvolt.com',
    /** Mints the viewer-scoped Databricks token; authenticated with Keycloak. */
    databricks: 'https://service-databricks-uat.tesvolt.com',
};
export const environment = {
    appSettings: {
        production: false,
        baseUrls,

        endpoints: {
            dataCollectorSignalRHub: `${baseUrls.dataCollector}/dataCollectorHub`,
            healthCheck: {
                aggregator: `${baseUrls.dataAggregator}/health-check`,
                deviceManagement: `${baseUrls.deviceManagement}/health-check`,
                dataCollector: `${baseUrls.dataCollector}/health-check`,
            },
        },
        configFile: 'assets/config/config.dev.json',
        /**
         * Databricks dashboard embedding. Empty until the workspace admin has
         * enabled the embedding policy, allowlisted our domain and published
         * the dashboard; the page renders a setup notice while unset.
         *
         * The same coordinates serve both embedding modes: the iframe, which
         * requires each viewer to hold a Databricks account, and the client
         * library, which renders from a token minted by `baseUrls.databricks`
         * and so needs no Databricks account at all.
         */
        databricks: {
            workspaceUrl: 'https://adb-7405613187348969.9.azuredatabricks.net',
            /**
             * Only needed by the external-viewer client library, not by the
             * iframe; kept here because it is part of the same coordinates.
             */
            workspaceId: '7405613187348969',
            /**
             * Dashboard chosen for the demo page. Taken from the dashboard
             * URL: /dashboardsv3/<id>/published. Lakeview ids are 32 hex
             * chars with no dashes, so they do not look like a classic UUID.
             */
            dashboardId: '01f175f7ea901942a3d5667d1d9f0580',
        },
        keycloak: {
            keycloakUrl: `${baseUrls.identity}`,
            keycloakRealm: 'Tesvolt',
            keycloakClientId: 'Tesvolt.ManagementPortal',
        },
    },
};
